module.exports = __webpack_public_path__ + "img/yimao_detail.d49e85aa.png";